import { render, staticRenderFns } from "./IberostarFoodHeader.vue?vue&type=template&id=edbb03a6&"
import script from "./IberostarFoodHeader.vue?vue&type=script&lang=js&"
export * from "./IberostarFoodHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelHeader } from 'vuetify/lib'
installComponents(component, {VExpansionPanelHeader})
